/*jslint browser: true*/
/*eslint-env browser*/
/*global jQuery*/

jQuery(document).ready(function ($) {
	'use strict';
	
	$(document).foundation();

	$.event.special.touchstart = {
        setup: function( _, ns, handle ) {
            //this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
            this.addEventListener("touchstart", handle, { passive: true });
        }
    };
    $.event.special.touchmove = {
        setup: function( _, ns, handle ) {
            //this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
            this.addEventListener("touchmove", handle, { passive: true });
        }
    };
	$.event.special.wheel = {
		setup: function( _, ns, handle ){
			this.addEventListener("wheel", handle, { passive: true });
		}
	};
	$.event.special.mousewheel = {
		setup: function( _, ns, handle ){
			this.addEventListener("mousewheel", handle, { passive: true });
		}
	};
	/* (function() {
		var supportsPassive = eventListenerOptionsSupported();  
	  
		if (supportsPassive) {
		  var addEvent = EventTarget.prototype.addEventListener;
		  overwriteAddEvent(addEvent);
		}
	  
		function overwriteAddEvent(superMethod) {
		  var defaultOptions = {
			passive: true,
			capture: false
		  };
	  
		  EventTarget.prototype.addEventListener = function(type, listener, options) {
			var usesListenerOptions = typeof options === 'object';
			var useCapture = usesListenerOptions ? options.capture : options;
	  
			options = usesListenerOptions ? options : {};
			options.passive = options.passive !== undefined ? options.passive : defaultOptions.passive;
			options.capture = useCapture !== undefined ? useCapture : defaultOptions.capture;
	  
			superMethod.call(this, type, listener, options);
		  };
		}
	  
		function eventListenerOptionsSupported() {
		  var supported = false;
		  try {
			var opts = Object.defineProperty({}, 'passive', {
			  get: function() {
				supported = true;
			  }
			});
			window.addEventListener("test", null, opts);
		  } catch (e) {}
	  
		  return supported;
		}
	  })(); */

	// slider
	$( '.home .owl-polo .products, .home .owl-kollekcio .products' ).addClass('owl-carousel owl-theme');
	$('.home .owl-polo .owl-carousel').owlCarousel({
		loop: true,
		margin: 34,
		dots: true,
		lazyLoad: true,
		//stagePadding: 8,
		navText: ["<i class='fa-light fa-angle-left'></i>","<i class='fa-light fa-angle-right'></i>"],
		responsive:{
			0:{
				items:2,
				nav:false
			},
			640:{
				items:3,
				nav:false
			},
			1024:{
				items:4,
				nav:true
			}
		}
	})
	$('.home .owl-kollekcio .owl-carousel').owlCarousel({
		loop: true,
		margin: 34,
		dots: true,
		lazyLoad: true,
		//stagePadding: 8,
		navText: ["<i class='fa-light fa-angle-left'></i>","<i class='fa-light fa-angle-right'></i>"],
		responsive:{
			0:{
				items:2,
				nav:false
			},
			640:{
				items:3,
				nav:false
			},
			1024:{
				items:3,
				nav:true
			}
		}
	})
	/*$('.owl-carousel').owlCarousel(
		{ 
			loop: true,
			animateIn: 'fadeIn',
			autoplay: false,
			smartSpeed: 0,
			autoplayHoverPause: true,
			mouseDrag: false,
			nav: true,
			dots: false,
			items: 1,
			navText: ["<i class='fal fa-chevron-left' aria-hidden='true'></i>","<i class='fal fa-chevron-right' aria-hidden='true'></i>"],
			responsive:{
				0:{
					dots: true,
					nav: false,
					mouseDrag: true,
				},
				640:{
					dots: true,
					nav: false,
					mouseDrag: true,
				},
				1024:{
					dots: true,
					nav: false,
				}
			}
		}
	);*/
	/*$('.velemeny .owl-carousel').owlCarousel(
		{ 
			loop: true,
			autoplay: true,
			smartSpeed: 500,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			nav: false,
			dots: true,
			items: 1,
			//navText: ["<i class='fal fa-chevron-left' aria-hidden='true'></i>","<i class='fal fa-chevron-right' aria-hidden='true'></i>"],
		}
	);*/
	/*$('.referencia .owl-carousel').owlCarousel(
		{ 
			loop: true,
			autoplay: true,
			slideTransition: 'linear',
			autoplayTimeout: 2000,
			//autoplaySpeed: 6000,
			smartSpeed: 2000,
			autoplayHoverPause: true,
			margin: 62,
			autoWidth: true,
			nav: false,
			dots: false,
			items: 5,
			
		}
	);*/


	/*$('.single-post .galeria .owl-carousel, .single-referencia .galeria .owl-carousel').owlCarousel(
		{ 
			loop: false,
			autoplay: true,
			smartSpeed: 500,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			nav: true,
			dots: false,
			navText: ['<span class="iconify" data-icon="uit:arrow-up-left" data-width="36" data-height="36"></span>','<span class="iconify" data-icon="uit:arrow-up-right" data-width="36" data-height="36"></span>'],
			responsive:{
				0:{
					items: 1
				},
				640:{
					items: 2
				},
				1024:{
					items: 2
				}
			}
		}
	);*/
	/* $('.home .tvcsoport .owl-carousel').owlCarousel(
		{ 
			loop: false,
			autoplay: false,
			smartSpeed: 500,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			nav: false,
			dots: false,
			//navText: ['<span class="iconify" data-icon="uit:arrow-up-left" data-width="36" data-height="36"></span>','<span class="iconify" data-icon="uit:arrow-up-right" data-width="36" data-height="36"></span>'],
			responsive:{
				0:{
					items: 1
				},
				640:{
					items: 3
				},
				1024:{
					items: 5
				}
			}
		}
	); */
	

	// add arial label to dots
	$('.owl-carousel').each(function() {
		//Find each set of dots in this carousel
	  	$(this).find('.owl-dot').each(function(index) {
			//Add one to index so it starts from 1
			$(this).attr('aria-label', index + 1 + '. slide');
	  	});
		$(this).find('.owl-next').each(function(index) {
			//Add arial-lable to to owl-next
			$(this).attr('aria-label', 'Következő slide');
		});
		$(this).find('.owl-prev').each(function(index) {
			//Add arial-lable to to owl-next
			$(this).attr('aria-label', 'Előző slide');
		});
	});
	
	/* $('.page-template-rolam .owl-carousel').owlCarousel(
		{
			loop: true,
			autoplay: true,
			smartSpeed: 500,
			autoplayTimeout: 3000,
			autoplayHoverPause: true,
			nav: true,
			dots: false,
			//navText: ['<div class="gomb"><span class="arrow left"></span></div>','<div class="gomb"><span class="arrow right"></span></div>'],
			//margin: 30,
			items: 1,
		}
	); */

	
	// kereses gomb
	$('i.fa-magnifying-glass').on('click', function() {
		$('#kereses').toggle();
		$(this).toggleClass('active');
	});


	// scroll up button
	$(window).on('scroll',function () {
		if ($(this).scrollTop() > 100) {
			$('#scrollup').fadeIn();
		} else {
			$('#scrollup').fadeOut();
		}
	});
	$('#scrollup').on('click',function () {
		$('html, body').animate({
			scrollTop: 0
		}, 400);
		return false;
	});

	// youtube iframe wrap
	/*$( '.single .entry-content iframe[src*="youtube.com"]').wrap( '<div class="responsive-embed widescreen">' );*/

	// accordion scroll to top
    /* $('.accordion-title').click(function() {
        var $this = this;
        setTimeout(function(){
            $('html,body').animate({scrollTop: $($this).closest('.accordion').find('.is-active').offset().top}, 'slow');
        }, 200);
    }); */

	// scroll to anchor
	/*$('a[href*=\\#]:not([href=\\#])').on('click', function() {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.substr(1) +']');
		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top - 90
			}, 500);
			return false;
		}
	});*/


	//$('ul.is-dropdown-submenu').attr('role','submenubar');

	//masonry
	/* var $grid = $('.grid').masonry({
		// options
		itemSelector: '.grid-item',
		columnWidth: '.grid-sizer',
		percentPosition: true,
		//gutter: 14,
		//horizontalOrder: true,
		//fitWidth: true

	}); */
	/*var $grid = $('.grid').packery({
		// options
		itemSelector: '.grid-item',
		columnWidth: '.grid-sizer',
		percentPosition: true,
		//gutter: '.gutter-sizer',
		//gutter: 14,
		//horizontalOrder: true,
		//fitWidth: true

	});
	// layout Masonry after each image loads
	$grid.imagesLoaded().progress( function() {
		$grid.packery('layout');
		//$grid.packery('shiftLayout');
	});*/

	/* var $grid = $('.grid').imagesLoaded( function() {
		// init Masonry after all images have loaded
		$grid.masonry({
			itemSelector: '.grid-item',
			columnWidth: '.grid-sizer',
			percentPosition: true,
			//gutter: 14,
			horizontalOrder: true,
		});
	}); */

	// webticker
	/* $('.ntick').webTicker({
		speed:'100',
		duplicate:true,
		//height:'60px', 
	}); */

	// add span to button
	//$( '.footer-top #block-11 .inline-btn, .header-newsletter-box form .inline-btn' ).append( '<span></span>' );

	// add class to cat list
	//$( '.cat-list a' ).addClass( 'wp-block-button__link wp-element-button' );

	// Adding class to div when inside viewport
	/*function isScrolledIntoView(elem) {
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();
		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height();
		return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
	}
	$(window).on( 'scroll', function () {
		$('.wp-block-acf-approach .container').each(function () {
			if (isScrolledIntoView(this) === true) {
				$(this).addClass('rotate');
			}
		});
	});*/

	// lottie play on show
	/* LottieInteractivity.create({
		player: '#lottieplay',
		mode: 'scroll',
		actions: [
			{
				visibility: [0.10, 1.0],
				type: 'play'
			}
		]
	}); */

	//deffer offscreen images
	$('.wpzoom-secondary-image-container img').attr('loading', 'lazy');

	//tax number
	if(window.location.href.indexOf("penztar") > -1)  {
		$('#billing_tax_number_field label').append( ' <abbr class="required" title="required">*</abbr>' );
		$('#billing_tax_number_field label span').hide();
		$('#billing_tax_number_field').addClass('validate-required');
		$('#billing_tax_number_field').hide();
		$('#billing_company').keyup(function() {
			if ( $(this).val().length == 0 ) {
				$('#billing_tax_number_field').removeClass('validate-required');
					// If Company is empty, hide Tax number
					$('#billing_tax_number_field').hide();
					// If Company is empty, empty Tax number
					$('#billing_tax_number').val('');
					// Set Tax number field to invalid, as it is empty again
					$('#billing_tax_number_field').removeClass('woocommerce-validated');
					$('#billing_tax_number_field').removeClass('woocommerce-invalid woocommerce-invalid-required-field');
				
			} else {
					$('#billing_tax_number_field').show();
					// Add required sign and remove the "not required" text from billing_tax_number_field
					$('#billing_tax_number_field').addClass('validate-required');
					$('#billing_tax_number_field label abbr').show();
					$('#billing_tax_number_field label span').hide();
			}
		}).keyup();

		//adószám maszk
		$('#billing_tax_number').mask('00000000-0-00', {placeholder: '________-_-__'});
		$('#billing_postcode').mask('0000', {placeholder: '____'});
		$('#shipping_postcode').mask('0000', {placeholder: '____'});
		$('#billing_phone').mask('+36-000000009', {placeholder: '+36-_________'});
	}

	// mobil link
	$( '.mobillink' ).on('click', function() {
		$(this).next().toggle();
	});

	//wrap cat description
	//$( '.term-description').wrap( '<div class="grid-container">' );

	//wrap badge
	$('ul.products li.product').each(function() {
		$(this).find( 'span.onsale' ).wrapAll( '<div class="jelvenyek"></div>' );
	});

});
